import React, {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import 'moment-timezone';
import NumberFormat from "react-number-format";
import {useTranslation} from "react-i18next";
import Images from "../../constants/lotto5Images";
import Printer from "../print/Printer";
import SweetAlert from "react-bootstrap-sweetalert";
import TicketDetail from "./../lotto6/TicketDetail";
import {
    fetchLotto5DrawingResult,
    fetchLotto5RecentBetReport,
    getRecentSize,
    setRecentSize
} from "../../store/rootAction";
import {moneyFormatter} from "../../utils/MoneyUtils";
import {UncontrolledTooltip} from "reactstrap";
import RefreshButton from "../../utils/RefreshButton";

export default function RecentBetting() {
    const {t} = useTranslation();

    const dispatch = useDispatch();
    const recentBetting = useSelector(state => state.lotto5.recentBetting);
    const user = useSelector(state => state.user);

    const [isShowRecentBet, setIsShowRecentBet] = useState(false);
    const [recentBetDetail, setRecentBetDetail] = useState(null);
    const [imageRotate, setImageRotate] = useState("");
    const [size, setSize] = useState(getRecentSize().lo5);

    const onShowDetail = (item) => {
        setIsShowRecentBet(true);
        setRecentBetDetail(item);
    };

    const onCloseDetail = () => {
        setIsShowRecentBet(false);
        setRecentBetDetail(null);
    };

    const afterPrint = () => {
        dispatch(fetchLotto5DrawingResult());
    };

    const getRecentBetting = () => {
        setImageRotate("rotate");
        dispatch(fetchLotto5RecentBetReport())
            .then(() => {
                setTimeout(() => {
                    setImageRotate("");
                }, 300);
            })
            .catch(() => {
                setTimeout(() => {
                    setImageRotate("");
                }, 300);
            });
    };

    const onChangeSize = (newSize) => {
        setSize(newSize);
        setRecentSize({lo5: newSize});
    };

    const renderBonusAmount = (amount, bonus, isShow) => {
        const currencyCode = user.userBalance.currencyCode;
        if (isShow) {
            return (
                <span>
                    {" + "}
                    <span id="bonus" className="text-danger">
                        ({moneyFormatter(bonus, currencyCode, "text-danger")})
                    </span>{" "}
                    = <span>{moneyFormatter((amount + bonus), currencyCode, "text-primary")}</span>
                    <UncontrolledTooltip placement="top" target="bonus">
                        {t("labels:report.bonus")}
                    </UncontrolledTooltip>
                </span>
            );
        }
        return "";
    };

    return (
        <>
            {recentBetting ? (
                <>
                    <div
                        className="col no-padding-div header-div-title header-text header-div-blue-light block-header position-static border-b-1 d-flex align-items-center last-ticket">
                        <span className="text-black kh-font-bold">
                            {t("labels:common.recentBet")}
                            <NumberFormat
                                className="in-recent-size"
                                isAllowed={({value}) => value < 11}
                                onBlur={() => {
                                    if (size > 0 && size < 11) getRecentBetting();
                                    else onChangeSize(3);
                                }}
                                onValueChange={({floatValue}) => onChangeSize(floatValue)}
                                value={size}
                            />
                            <span>
                                {t("labels:common.draw")}
                            </span>
                        </span>
                        <RefreshButton
                            onClick={getRecentBetting}
                            className={imageRotate}
                        />
                    </div>
                    <div className="table-responsive dashboard-fix-height header-div-white fade-in">
                        <table className="table table-current-bet">
                            <tbody className=" header-div-white">
                            {recentBetting.map((item, i) => (
                                <React.Fragment key={i}>
                                    <tr className="draw-header-bg">
                                        <td className="d-flex justify-content-between draw-code-recent-bet dashboard-padding-left"
                                            colSpan={7}>
                                            <div>{`${item.drawLabel}`}</div>
                                            {/*{(isBonus(item.bonusCode) && item.status) ? <span>*/}
                                            {/*    <span*/}
                                            {/*        className={"kh-font-bold left-bet-type-" + item.bonusCode}>{t("labels:ticket.bonus_label_ticket")}{" "}*/}
                                            {/*        {t("labels:betPrefix." + item.bonusCode)}*/}
                                            {/*</span>*/}
                                            {/*    </span> : ""}*/}
                                        </td>
                                    </tr>
                                    {item.tickets.map((row, k) => {
                                        let items = row.items;
                                        const currencyCode = user.userBalance.currencyCode;
                                        return (
                                            <tr key={k} className="table-recent-betting">
                                                <td colSpan={3} className="text-center">
                                                    <div className="header-draw">
                                                        <div
                                                            className="text-left ticket-code-recent-bet text-primary"
                                                            onClick={() => onShowDetail(row)}
                                                        >
                                                            {row.ticketCode}
                                                        </div>
                                                        <div>
                                                            {(row?.winAmount > 0 || row?.bonusAmount > 0 || !row.status) ? (
                                                                <Printer
                                                                    data={row}
                                                                    lottoType="LOTTO5"
                                                                    afterPrint={afterPrint}
                                                                />
                                                            ) : null}
                                                        </div>
                                                    </div>
                                                    {items.map((e, idx) => (
                                                        <div key={idx}
                                                             className="d-flex justify-content-start text-center">
                                                            <div
                                                                className="w-25">{t("labels:drawing.drawPrefix." + e.betCode)}</div>
                                                            <NumberFormat
                                                                value={e.betAmount}
                                                                displayType={'text'}
                                                                thousandSeparator={true}
                                                                suffix={" "}
                                                            />
                                                            <div className="pl-1 pr-1">X</div>
                                                            <div>{e.betValue}</div>
                                                            <div className="pl-1 pr-1">=</div>
                                                            {row.status === false
                                                                ? <span className="text-danger">???</span>
                                                                : (e.winAmount <= 0 && row.bonusAmount <= 0)
                                                                    ? <span className="text-danger">0</span>
                                                                    : (
                                                                        <span>
                                                                                {moneyFormatter(e.winAmount, currencyCode, "text-primary")}{" "}
                                                                            {renderBonusAmount(e.winAmount, row.bonusAmount, (row.bonusAmount > 0 && items.length === 1))}
                                                                            </span>
                                                                    )}
                                                        </div>
                                                    ))}
                                                    {items.length > 1 &&
                                                        <div className='text-left d-flex'>
                                                            <div
                                                                className="w-25 text-center">{t("labels:recentBet.sub_total")}</div>
                                                            <span>
                                                                    {moneyFormatter(row.betAmount, row.currencyCode)} / {!row.status
                                                                ? <span className="text-danger">???</span>
                                                                : moneyFormatter(row.winAmount, row.currencyCode, "text-primary")}{" "}
                                                                {renderBonusAmount(row.winAmount, row.bonusAmount, row.bonusAmount > 0)}
                                                                </span>
                                                        </div>
                                                    }
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </React.Fragment>
                            ))}
                            </tbody>
                        </table>
                        {recentBetting.length === 0 ? (
                            <img className="data-not-found" src={Images.dataNotFound} alt="..."/>
                        ) : ''}
                    </div>
                </>
            ) : null}
            <SweetAlert
                title=" "
                show={isShowRecentBet}
                onConfirm={onCloseDetail}
                confirmBtnText={t("labels:common.close")}
                showCancel={false}
                btnSize="lg"
            >
                <TicketDetail dataDetail={recentBetDetail}/>
            </SweetAlert>
        </>
    );
}
